import GameScreen from '../components/GameScreen';

function ResultsPendingScreen({ gameName, roomCode, onReconnect, onQuit, timerSeconds }) {
  return (
    <GameScreen
      gameName={gameName}
      roomCode={roomCode}
      onReconnect={onReconnect}
      onQuit={onQuit}
      timerSeconds={timerSeconds}
      backgroundImage="/results-pending-bg.png"
    />
  );
}

export default ResultsPendingScreen;
